import React from 'react';
import Icon from '../../../components/AppIcon';

const WorkDescription = ({ description, equipment, procedures }) => {
  return (
    <div className="bg-card rounded-lg border border-border p-6 shadow-card">
      <div className="flex items-center gap-2 mb-4">
        <Icon name="FileText" size={20} color="var(--color-primary)" />
        <h2 className="text-lg font-semibold text-foreground">Work Description</h2>
      </div>
      <div className="space-y-4">
        <div>
          <h3 className="text-sm font-medium text-foreground mb-2">Scope of Work</h3>
          <p className="text-sm text-muted-foreground leading-relaxed">{description}</p>
        </div>

        <div className="border-t border-border pt-4">
          <h3 className="text-sm font-medium text-foreground mb-3">Equipment & Tools Required</h3>
          <div className="grid grid-cols-1 sm:grid-cols-2 gap-2">
            {equipment?.map((item, index) => (
              <div key={index} className="flex items-center gap-2 text-sm text-muted-foreground">
                <Icon name="CheckCircle2" size={16} color="var(--color-success)" />
                <span>{item}</span>
              </div>
            ))}
          </div>
        </div>

        <div className="border-t border-border pt-4">
          <h3 className="text-sm font-medium text-foreground mb-3">Safety Procedures</h3>
          <div className="space-y-2">
            {procedures?.map((procedure, index) => (
              <div key={index} className="flex items-start gap-2">
                <span className="inline-flex items-center justify-center w-6 h-6 rounded-full bg-primary/10 text-primary text-xs font-medium flex-shrink-0 mt-0.5">
                  {index + 1}
                </span>
                <p className="text-sm text-muted-foreground flex-1">{procedure}</p>
              </div>
            ))}
          </div>
        </div>
      </div>
    </div>
  );
};

export default WorkDescription;